module.exports = __webpack_public_path__ + "img/angle-circle-left.87569cd.svg";